export default {
  colours: {
    primary: "#054a61"
  }
};
